/**
 * Notifications API service
 */

import { httpClient } from '@/utils/httpClient';

export interface APINotification {
    id: number | string;
    type?: string | null;
    priority?: string | null;
    title?: string | null;
    message?: string | null;
    created_at?: string | null;
    timestamp?: string | null;
    is_read?: boolean;
    read?: boolean;
    action_url?: string | null;
    metadata?: Record<string, unknown> | null;
}

interface DRFList<T> {
    count: number;
    next: string | null;
    previous: string | null;
    results: T[];
}

const buildQuery = (params?: { page?: number; page_size?: number }): string => {
    const usp = new URLSearchParams();
    if (params?.page !== undefined) usp.append('page', String(params.page));
    if (params?.page_size !== undefined) usp.append('page_size', String(params.page_size));
    const s = usp.toString();
    return s ? `?${s}` : '';
};

export const notificationsService = {
    async list(params?: { page?: number; page_size?: number }): Promise<APINotification[]> {
        const qs = buildQuery(params);
        const response = await httpClient.get<DRFList<APINotification> | APINotification[]>(`/notifications/${qs}`);
        return Array.isArray(response) ? response : (response.results ?? []);
    },

    async markAsRead(id: string): Promise<void> {
        await httpClient.post<void, Record<string, never>>(
            `/notifications/${id}/mark-as-read/`,
            {},
            { notifyOnSuccess: false }
        );
    },

    async markAllAsRead(): Promise<void> {
        await httpClient.post<void, Record<string, never>>(
            '/notifications/mark-all-as-read/',
            {},
            { notifyOnSuccess: false }
        );
    },

    async deleteNotification(id: string): Promise<void> {
        await httpClient.post<void, Record<string, never>>(
            `/notifications/${id}/delete/`,
            {},
            { notifyOnSuccess: false }
        );
    },
};

export default notificationsService;
